(function (upp) {
    'use strict';

    upp.service('restaurantService', ['appi', '$q',
        function (appi, $q) {
            var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE;

            /**
             * Retrieves the restaurant categories content. And store as a cache
             *
             * TODO: use http cache instead https://docs.angularjs.org/api/ng/service/$http
             * @method get
             * @return {Promise} Returns a promise that will be fulfilled(restaurant list content) or rejected(error)
             */
            var getCategories = (function ($q, angular) {
                var contentCategories = {}, _copy = angular.copy;

                return function () {
                    var deferred = $q.defer();

                    if (contentCategories.result) {
                        deferred.resolve(contentCategories.result);
                    } else {
                        appi.http.get(URL_API_REST_SERVER + 'restaurant/')
                            .then(function (response) {
                                contentCategories.result = _copy(response.data);
                                deferred.resolve(contentCategories.result);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                };
            }($q, angular));

            /**
             * Retrieves the foods of a category. And store as a cache in a map with the id as a key and the content as the value
             *
             * TODO: use http cache instead https://docs.angularjs.org/api/ng/service/$http
             * @method get
             * @return {Promise} Returns a promise that will be fulfilled(foods) or rejected(error)
             */
            var getFoods = (function ($q, angular) {
                var contentFoods = {}, _copy = angular.copy;

                return function (id) {
                    var deferred = $q.defer();

                    if (contentFoods[id]) {
                        deferred.resolve(contentFoods[id]);
                    } else {
                        appi.http.get(URL_API_REST_SERVER + 'restaurant/' + id)
                            .then(function (response) {
                                contentFoods[id] = _copy(response.data);
                                deferred.resolve(contentFoods[id]);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                };
            }($q, angular));

            /**
             * Retrieve the food by a id. And store as a cache in a map with the id as a key and the content as the value
             *
             * TODO: use http cache instead https://docs.angularjs.org/api/ng/service/$http
             * @method get
             * @return {Promise} Returns a promise that will be fulfilled(foods) or rejected(error)
             */
            var getFood = (function ($q, angular) {
                var contentFood = {}, _copy = angular.copy;

                return function (id) {
                    var deferred = $q.defer();

                    if (contentFood[id]) {
                        deferred.resolve(contentFood[id]);
                    } else {
                        appi.http.get(URL_API_REST_SERVER + 'restaurant/food/' + id)
                            .then(function (response) {
                                contentFood[id] = _copy(response.data);
                                deferred.resolve(contentFood[id]);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                };
            }($q, angular));

            return {
                getCategories: getCategories,
                getFoods: getFoods,
                getFood: getFood
            };
        }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/restaurant/services/restaurant-services.js